// *******************************************************************************
// Close Info Bar
// *******************************************************************************

// const infoBar = document.querySelector('.info-bar');

// const hideInfoBar = () => {
//   infoBar.classList.add('d-xs-none');
//   document.body.style.setProperty('--top-bar-height', '0px');
// };

// attachEvent('.info-bar__close', 'click', () => {
//   hideInfoBar();
//   Cookies.set('info_bar_accepted', true, { expires: 7 });
// });

// if (infoBar && Cookies.get('info_bar_accepted')) {
//   hideInfoBar();
// }
